// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /*
  --swiper-pagination-color: var(--swiper-theme-color);
  */
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}
.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: scale(0.33);
  position: relative;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  background: #000;
  opacity: 0.2;
}
button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  -webkit-appearance: none;
          appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}
.swiper-pagination-bullet:only-child {
  display: none !important;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  background: var(--swiper-theme-color);
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-container-vertical > .swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}
.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 6px 0;
  display: block;
}
.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}
.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
}
.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}
.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

/* Progress */
.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-theme-color);
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}
.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}
.swiper-container-horizontal > .swiper-pagination-progressbar, .swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
.swiper-container-vertical > .swiper-pagination-progressbar, .swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}

.swiper-pagination-white {
  --swiper-pagination-color: #ffffff;
}

.swiper-pagination-black {
  --swiper-pagination-color: #000000;
}

.swiper-pagination-lock {
  display: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/swiper/components/pagination/pagination.scss"],"names":[],"mappings":"AAEA;EACE;;GAAA;AACF;;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;AAAF;AACE;EACE,UAAA;AACJ;;AAEA,kBAAA;AACA;;;EAGE,YAAA;EACA,OAAA;EACA,WAAA;AACF;;AACA,YAAA;AACA;EACE,gBAAA;EACA,YAAA;AAEF;AADE;EACE,sBAAA;EACA,kBAAA;AAGJ;AADE;EACE,mBAAA;AAGJ;AADE;EACE,mBAAA;AAGJ;AADE;EACE,sBAAA;AAGJ;AADE;EACE,sBAAA;AAGJ;AADE;EACE,sBAAA;AAGJ;AADE;EACE,sBAAA;AAGJ;;AAAA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAGF;AAFW;EACP,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;UAAA,gBAAA;AAIJ;;AAFE;EACE,eAAA;AAKJ;AAFE;EACE,wBAAA;AAIJ;;AADA;EACE,UAAA;EACA,qCAAA;EAAA,qEAAA;AAIF;;AAAE;EACE,WAAA;EACA,QAAA;EACA,oCAAA;AAGJ;AAFI;EACE,aAAA;EACA,cAAA;AAIN;AAFI;EACE,QAAA;EACA,2BAAA;EACA,UAAA;AAIN;AAHM;EACE,qBAAA;EACA,sCAAA;AAKR;;AAEI;EACE,aAAA;AACN;AACI;EACE,SAAA;EACA,2BAAA;EACA,mBAAA;AACN;AAAM;EACE,uCAAA;AAER;AAEE;EACE,wCAAA;AAAJ;;AAGA,aAAA;AACA;EACE,+BAAA;EACA,kBAAA;AAAF;AACE;EACE,qCAAA;EAAA,qEAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;AACJ;AACE;EACE,2BAAA;AACJ;AACE;EAEE,WAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;AAAJ;AAEE;EAEE,UAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AADJ;;AAKE;EACE,kCAAA;AAFJ;;AACE;EACE,kCAAA;AAEJ;;AACA;EACE,aAAA;AAEF","sourcesContent":["@import '../../swiper-vars.scss';\n\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n  &.swiper-pagination-hidden {\n    opacity: 0;\n  }\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n  .swiper-pagination-bullet {\n    transform: scale(0.33);\n    position: relative;\n  }\n  .swiper-pagination-bullet-active {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullet-active-main {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullet-active-prev {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullet-active-next {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-next-next {\n    transform: scale(0.33);\n  }\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 50%;\n  background: #000;\n  opacity: 0.2;\n  @at-root button#{&} {\n    border: none;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    appearance: none;\n  }\n  .swiper-pagination-clickable & {\n    cursor: pointer;\n  }\n\n  &:only-child {\n    display: none !important;\n  }\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n\n.swiper-container-vertical {\n  > .swiper-pagination-bullets {\n    right: 10px;\n    top: 50%;\n    transform: translate3d(0px, -50%, 0);\n    .swiper-pagination-bullet {\n      margin: 6px 0;\n      display: block;\n    }\n    &.swiper-pagination-bullets-dynamic {\n      top: 50%;\n      transform: translateY(-50%);\n      width: 8px;\n      .swiper-pagination-bullet {\n        display: inline-block;\n        transition: 200ms transform, 200ms top;\n      }\n    }\n  }\n}\n.swiper-container-horizontal {\n  > .swiper-pagination-bullets {\n    .swiper-pagination-bullet {\n      margin: 0 4px;\n    }\n    &.swiper-pagination-bullets-dynamic {\n      left: 50%;\n      transform: translateX(-50%);\n      white-space: nowrap;\n      .swiper-pagination-bullet {\n        transition: 200ms transform, 200ms left;\n      }\n    }\n  }\n  &.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: 200ms transform, 200ms right;\n  }\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n  .swiper-pagination-progressbar-fill {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: scale(0);\n    transform-origin: left top;\n  }\n  .swiper-container-rtl & .swiper-pagination-progressbar-fill {\n    transform-origin: right top;\n  }\n  .swiper-container-horizontal > &,\n  .swiper-container-vertical > &.swiper-pagination-progressbar-opposite {\n    width: 100%;\n    height: 4px;\n    left: 0;\n    top: 0;\n  }\n  .swiper-container-vertical > &,\n  .swiper-container-horizontal > &.swiper-pagination-progressbar-opposite {\n    width: 4px;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n}\n@each $paginationColorName, $paginationColorValue in $colors {\n  .swiper-pagination-#{'' + $paginationColorName} {\n    --swiper-pagination-color: #{'' + $paginationColorValue};\n  }\n}\n.swiper-pagination-lock {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
